import React from 'react'
import { Link } from 'react-router-dom'
import moment from "moment"
import ProductType from './ProductType'
import classNames from 'classnames'
import { Tag, Checkbox } from 'antd'


const BatchesErrorRows = (props) => {
    const { item, onChangeProductType, loadingSend, selectedItems, updateSelectedOrders, handleChangeBrand } = props
    const { status, created_at, product_types, items_count, user_create, partner, error_items_count, note , lasers, brand, production_times, tags} = item

    const _generateLevel = (level) => {
        const color = level === 3 ? 'rgb(255 45 0)' : level === 2 ? '#FFD300' : ''
        switch (level) {
            case 3:
                return <Tag className={classNames(`tag-highest`)} color={color}>highest</Tag>
            case 2:
                return <Tag className={classNames(`tag-high`)} color={color}>high</Tag>
            default:
                return <Tag className={classNames(`tag-medium`)} color={color}>medium</Tag>
        }
    }

    const color = classNames({
        'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
        'printing progress-bar-animated progress-bar-striped': status === 'printing',
        'printed': status === 'printed',
        'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
        'transferred': status === 'transferred',
        'confirmed': status === 'confirmed',
        'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
        'sewing': status === 'sewing',
        'completed': status === 'completed' || status === 'done'
    })

    const _detectChecked = () => {
        return selectedItems.includes(item._id)
    }

    const _handleChange = () => {
        const isChecked = _detectChecked()

        updateSelectedOrders(item._id, !isChecked)
    }

    const warningBatch = !!production_times && !!production_times.length && !production_times.every(i => !i || !i.overtime || i.overtime < -1.5)
    const overtimed = !!warningBatch && !!production_times.find(i =>!!i && !!i.overtime && i.overtime > 0)
    const almostOvertime = !!warningBatch && !overtimed && !!production_times.find(i =>!!i && !!i.overtime && i.overtime >= -1.5 && i.overtime <= 0)
    const wraningStyle = !!warningBatch ? { background: `rgb(${(!!almostOvertime ? "255, 208, 26, 0.3" : (overtimed ? "223, 31, 31, 0.2" : ''))})` } : {}
    const isGiftTag = Array.isArray(tags) && tags.includes('gift')
    const isSampleTag = Array.isArray(tags) && tags.includes('sample')
    const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
    const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
    const isUIDSAMPLETag = Array.isArray(tags) && tags.includes('UIDSAMPLE')
    const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
    const isTikTokTag = Array.isArray(tags) && tags.includes('tiktok')
    const is24hTag = Array.isArray(tags) && tags.includes('24h')
    const isCutOffTag = Array.isArray(tags) && tags.includes('cutoff')
    const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
    const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
    const isSLLTag = Array.isArray(tags) && tags.includes('SLL')

    return (
        <tr key={item._id} style={wraningStyle}>
            <td className='OrderCheckbox'>
                <Checkbox disabled={loadingSend} onChange={_handleChange} checked={_detectChecked()} />
            </td>
            <td className="NameBatches">
                <Link to={`/batches/${item._id}`} className="d-block">
                    {item.name}
                </Link>
                {
                    _generateLevel(item.level_number)
                }
                {   
                    isGiftTag && 
                    <div>
                        <Tag color="#6c757d">Hàng tặng</Tag>
                    </div>
                }

                {
                    isSampleTag && 
                    <div>
                        <Tag color="#6c757d">Hàng mẫu</Tag>
                    </div>
                }

                {
                    isFbaTag && 
                    <div>
                        <Tag color="#6c757d">FBA</Tag>
                    </div>
                }

                {
                    isFastShipTag && 
                    <div>
                        <Tag color="#6c757d">Ship nhanh</Tag>
                    </div>
                }

                {
                    isUIDSAMPLETag && 
                    <div>
                        <Tag color="#6c757d">UIDSAMPLE</Tag>
                    </div>
                }

                {
                    isFastProductionTag && 
                    <div>
                        <Tag color="#FFA500">Sản xuất nhanh</Tag>
                    </div>
                }

                {
                    isTikTokTag && 
                    <div>
                        <Tag color="#dc3644">TIKTOK</Tag>
                    </div>
                }

                {
                    is24hTag &&
                    <div>
                        <Tag color="#dc3644">24h</Tag>
                    </div>
                }

                {
                    isCutOffTag && 
                    <div>
                        <Tag color="#FF6600">cutoff</Tag>
                    </div>
                }

                {
                    isCutOffNoel &&
                    <div>
                        <Tag color="#FF6600">cutoff_noel</Tag>
                    </div>
                }

                {
                    isCutOffNewYear &&
                    <div>
                        <Tag color="#FF6600">cutoff_new_year</Tag>
                    </div>
                }

                {
                    isSLLTag &&
                    <div>
                        <Tag color="#fdb813">SLL</Tag>
                    </div>
                }
            </td>
            <td className='colDate'>
                {created_at ? moment(created_at).format("HH:mm DD/MM/YYYY") : "-"}
            </td>
            <ProductType 
                types={product_types} 
                onChangeProductType={onChangeProductType} 
                brand={brand} 
                handleChangeBrand={handleChangeBrand}
            />
            <td className="Status">
                <span className={`badge ${color} badge-pill`}>{status}</span>
            </td>
            <td className="text-center font-weight-bold text-danger Quantity">{error_items_count ? error_items_count : 0}</td>
            <td className='CuttingAt'>{ lasers.length ? moment(lasers[0].started_at).format("HH:mm DD/MM/YYYY") : '-' }</td>
            <td className="Partner">{!!partner.name ? partner.name : '-'}</td>
            <td className="Partner">-</td>
            <td className="HumanCreate">{!!user_create ? user_create : '-'}</td>
            <td className="Note">{!!note ? note : '-'}</td>
        </tr>
    )
}

export default BatchesErrorRows